var render = function render(){var _vm=this,_c=_vm._self._c;return _c('horse-table',{attrs:{"headers":_vm.headers,"filters":_vm.filters,"sort-by":_vm.sortBy,"is-surrogate-per-location-list":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }